const totalByColumn = (items, series) => {
  return series.map((nombre) => {
    return items
      .flatMap((obj) => obj.series)
      .filter((serie) => serie.name === nombre)
      .reduce((sum, serie) => sum + serie.amount, 0);
  });
};

export default totalByColumn;
